export enum MARKS_STATUS {
    MARCAS_INCOMPLETAS = 'MARCAS_INCOMPLETAS',
    SIN_MARCACION = 'SIN_MARCACION',
    MARCAS_COMPLETAS = 'MARCAS_COMPLETAS'
}

export enum MARKS_ACTIONS {
    DELETE = 3,
    EDIT = 2,
    ADD = 1,
    NO_ACTIONS = 0
}

export const ALLOWED_REQUEST_TYPES = new Set([1, 11, 15, 16, 24]);
export const MARK_REGULARIZATION_TYPES = new Set([4, 27, 28]);
export const PENDING_STATES = new Set([1, 4, 5]);
export const APPROVED_STATES = new Set([3]);
export const HIDDEN_STATES = new Set([2, 6, 7]);
export const REGUL_REASONS_WITH_EXPLANATION = new Set(['1', '2', '6']);